import React, { Component } from 'react'
import request from '../../lib/requester'
import Autocomlete from '../Autocomplete'
class Member extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lovProgramMember: [],
            lovBranch: [],
            totalParticipant: '',
            suggestions: [],
            value: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }

    componentDidMount = () => {
        this.getProgramMember()
    }

    getProgramMember = () => {
        let url = '/api/v1/program/member'
        request.get(url, {
            success: function (response) {
                this.setState({ lovProgramMember: response.data.data })
            }.bind(this),
            error: function (e) {
                console.log(e)
            }
        })
    }

    renderLovProgramMember = () => {
        return (
            <select className="form-control" name="programMember" onChange={this.handleChangeInput.bind(this)}>
                <option>- Select Participants -</option>
                {this.state.lovProgramMember.map((item, index) => (
                    <option value={item.program_member_id} key={index}>{item.description}</option>
                ))}
            </select>
        )
    }

    handleChangeInput = (event) => {
        let value = event.target.value
        let name = event.target.name

        this.setState({ [name]: value })
        window.setTimeout(() => {
            console.log(this.state)
        }, 100)
    }

    renderBranch = () => {
        return (
            <select className="form-control" name="budgetType" onChange={this.handleChangeInput.bind(this)}>
                <option>- Select Branch -</option>
                {this.state.lovBranch.map((item, index) => (
                    <option value={item.branch_od} key={index}>{item.branch_name}</option>
                ))}
            </select>
        )
    }

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        {/* <Wizzard currentStep="member" /> */}
                        <div className="row ml-1">
                            <div className="col-lg-12 col-sx-12">
                                <div className="card card-info">
                                    <div className="card-body">
                                        <form className="form-horizontal">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Program Member</label>
                                                        <div className="col-sm-8">
                                                            {this.renderLovProgramMember()}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Total Participant</label>
                                                        <div className="col-sm-8">
                                                            <input type="number" name="totalParticipant" className="form form-control" value={this.state.totalParticipant} onChange={this.handleChangeInput.bind(this)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Branch</label>
                                                        <div className="col-sm-8">
                                                            {this.renderBranch()}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Participant</label>
                                                        <div className="col-sm-8">
                                                            <Autocomlete suggestions={[{ text: 'Participant 1', value: 1}, { text: 'Participant 2', value: 2}, { text: 'Participant 3', value: 3}]} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <button className="btn btn-success">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Member